import { ILocation } from '~/Models/DTO/Location.models';
import { useLocations } from '~/store/provider';
import { useNavigationContext, useNavigation, useProvider } from '~/Hooks';

import { Route } from '~/Constants/Routes.constants';
import { CreateLocation } from './LocationEditTypes';

export const useCreateLocation = () => {
  const { blockNavigation } = useNavigationContext();
  const { dangerouslyPushBack } = useNavigation();
  const { createLocation: createLocationAction } = useLocations();
  const { currentProvider } = useProvider();

  const createLocation = async ({ setIsLoading, currentLocation }: CreateLocation) => {
    let hasError = false;
    const setRawData = (response: any) => {
      if (response.status === 400) {
        hasError = true;
      }
    };
    try {
      await createLocationAction(
        currentProvider?.domain || '',
        currentLocation as ILocation,
        setRawData,
      );
    } catch (error) {
      hasError = true;
      console.error(error);
    } finally {
      setIsLoading(false);
    }
    if (!hasError) {
      blockNavigation(false);
      dangerouslyPushBack(Route.PROVIDER_LOCATIONS);
    }
  };

  return { createLocation };
};
